import { render, staticRenderFns } from "./MetadataEditor.vue?vue&type=template&id=4b3f275a&"
import script from "./MetadataEditor.vue?vue&type=script&lang=ts&"
export * from "./MetadataEditor.vue?vue&type=script&lang=ts&"
import style0 from "./MetadataEditor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports